import React from "react";

import "./spinner.css";

const Spinner = () => {
  return (
    <div className="loadingio-spinner-spinner-3oqlumcrxit">
      <div className="ldio-mzy1cv9q2v9">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Spinner;
